<template><div><h1 id="_8-zeitabschnitte-in-funtrade" tabindex="-1"><a class="header-anchor" href="#_8-zeitabschnitte-in-funtrade"><span>8. Zeitabschnitte in funtrade</span></a></h1>
<h2 id="_8-1-beschreibung" tabindex="-1"><a class="header-anchor" href="#_8-1-beschreibung"><span>8.1. Beschreibung</span></a></h2>
<p>Unter &quot;Zeitabschnitt&quot; werden in diesem Dokument alle Arbeiten verstanden, die im Hinblick auf die Gliederung von Daten in einem bestimmten Zeitabschnitt zu berücksichtigen sind. Insbesondere sind dies:</p>
<ul>
<li>
<p>Jahreswechsel (Kalenderjahr)</p>
</li>
<li>
<p>Geschäftsjahr</p>
</li>
<li>
<p>Wiederkehrende Arbeiten/ Parametrisierung (z.B. Saisonwechsel, Monatsende)</p>
</li>
</ul>
<p>Die zeitliche Abgrenzung von Vorgängen, Statistiken, Daten etc., bringt in jedem System eine Reihe von Arbeiten mit sich. Ziel dieses Dokuments ist es, den verantwortlichen Mitarbeitern auf allen Stufen eine Zusammenstellung der möglichen / notwendigen Arbeiten in funtrade in die Hand zu geben. Da funtrade ein hochgradig parametrisierbares System ist, können in diesem Dokument an vielen Stellen nur Hinweise, aber keine konkreten Arbeitsanleitungen gemacht werden.</p>
<p>Das detaillierte Vorgehen muss bei jedem Kunden entsprechend den aktuellen Voraussetzungen geplant, durchgeführt und schliesslich für den nächsten Zeitabschnitt dokumentiert werden, denn der folgt bestimmt.</p>
<p>Im Folgenden werden Hinweise auf zu erledigende Arbeiten gegeben, jeweils getrennt nach den Bereichen:</p>
<ul>
<li>
<p>Adressverwaltung</p>
</li>
<li>
<p>Lagerverwaltung</p>
</li>
<li>
<p>Auftragsverwaltung</p>
</li>
<li>
<p>Debitorenverwaltung</p>
</li>
<li>
<p>Projektverwaltung</p>
</li>
<li>
<p>Dauerauftragsverwaltung</p>
</li>
<li>
<p>Veranstaltungen</p>
</li>
<li>
<p>Statistiken, Auswertungen</p>
</li>
<li>
<p>Systemorganisation.</p>
</li>
</ul>
<p>Dabei liegt der Fokus auf Arbeiten, die für die jeweiligen Zeitabschnitte / Bereiche in funtrade notwendig sind. Allgemeine, für die Datenpflege wichtige und deshalb regelmässig durchzuführende Aufgaben werden nicht erwähnt.</p>
<p>Wo nötig und möglich wird direkt auf die entsprechenden Dokumentationen verwiesen.</p>
<p>Pro aufgeführtem Arbeitsschritt ist angegeben, für welchen Zeitabschnitt dieser Arbeitsschritt notwendig bzw. empfehlenswert ist. Wenn mehrere Zeitabschnitte aufgeführt sind, kann der zugehörige Arbeitsschritt für alle gelten.</p>
<h2 id="_8-2-adressverwaltung" tabindex="-1"><a class="header-anchor" href="#_8-2-adressverwaltung"><span>8.2. Adressverwaltung</span></a></h2>
<p><strong>Zeitabschnitte / Kategorie:</strong></p>
<ul>
<li>J = Jahreswechsel (Kalenderjahr)</li>
<li>G = Geschäftsjahr</li>
<li>W = Wiederkehrende Arbeiten/Parametrisierung bei Bedarf</li>
</ul>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>J</td>
<td>Stati Z S K</td>
<td>Aktualisierungslauf</td>
<td>EDV</td>
<td>&gt;Regelmässige Dienste &gt; Personenstatus/Adressprofil korrig.</td>
<td>Adressverwaltung</td>
</tr>
<tr>
<td>J</td>
<td>Zusagen</td>
<td>Bereinigungslauf Zusagen (Austritte)</td>
<td>EDV bzw. bei speziellen Anforderungen VDZC</td>
<td>&gt;Adressverwaltung &gt;Sammelbearbeitung, Produktion &gt;Zusagen, jährliche Austritte</td>
<td>Adressverwaltung</td>
</tr>
<tr>
<td>J</td>
<td>Zusagenbeträge</td>
<td>überprüfen, ggf. anpassen</td>
<td>Marketing</td>
<td></td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Merkmale</td>
<td>überprüfen, ggf. anpassen</td>
<td>Marketing</td>
<td></td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Ereignisse</td>
<td>überprüfen, ggf. anpassen: insbesondere Eintragungen Konto/Kostenstelle/Kostenträger und Akquisitionscode.</td>
<td>Marketing</td>
<td>&gt;Tabellen</td>
<td>Ereignisse und Ereignispositionen</td>
</tr>
<tr>
<td>W</td>
<td>Akquisitionscodes</td>
<td>überprüfen, ggf. anpassen</td>
<td>Marketing</td>
<td>&gt;Tabellen</td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Dubletten markieren</td>
<td>Einrichten / Anpassen Job</td>
<td>EDV</td>
<td>&gt;Adressverwaltung &gt;Sammelbearbeitung &gt;dubletten/Haushalt-Verwaltung &gt;Doubl. autom. suchen und markieren   Methode 3</td>
<td>Adressverwaltung</td>
</tr>
<tr>
<td>W</td>
<td>Dublettenbereinigung</td>
<td>Einrichten / Anpassen Job</td>
<td>EDV</td>
<td>&gt;Adressverwaltung &gt;Sammelbearbeitung &gt;dubletten/Haushalt-Verwaltung &gt;markierte Dubletten bereinigen/zusammenführen</td>
<td>Adressverwaltung</td>
</tr>
<tr>
<td>W</td>
<td>Verdankungen</td>
<td>Steuertabelle überprüfen, ggf. anpassen</td>
<td>Marketing</td>
<td>Tabellen &gt;Diverse Tabellen &gt;Verdankungen Steuertabelle</td>
<td>Verdankungen-Steuertabelle</td>
</tr>
<tr>
<td>W</td>
<td>Korrespondenz</td>
<td>Korrespondenzarten überprüfen, ggf. anpassen</td>
<td>Marketing</td>
<td>Tabellen &gt;Korrespondenz &gt;Korrespondenzarten</td>
<td>Korrespondenz</td>
</tr>
<tr>
<td>W</td>
<td>Adresspflege</td>
<td>Botenfiles, PLZ-Stämme aktualisieren</td>
<td>EDV bzw. VDZC</td>
<td></td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Jobs</td>
<td>Kontrolle in &quot;Regelmässige Dienste&quot;, ob die notwendigen  Jobs im System eingerichtet sind</td>
<td>EDV bzw. VDZC</td>
<td>Systemorganisation &gt;Regelmässige Dienste</td>
<td></td>
</tr>
</tbody>
</table>
<ul>
<li><RouteLink to="/manual/customer/ereignisse-und-ereignispositionen.html" title="4. Ereignisse">Ereignisse und Ereignispositionen</RouteLink></li>
<li><RouteLink to="/referenz/refs/ft.refdata.vdanksteuer.html" title="Verdankungssteuertabelle">Verdankungen-​Steuertabelle</RouteLink></li>
<li><RouteLink to="/referenz/refs/ft.refdata.korresp.html" title="Korrespondenz">Korrespondenz</RouteLink></li>
</ul>
<h2 id="_8-3-lagerverwaltung" tabindex="-1"><a class="header-anchor" href="#_8-3-lagerverwaltung"><span>8.3. Lagerverwaltung</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>W, G</td>
<td>Inventur</td>
<td>durchführen</td>
<td>Lager</td>
<td></td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Medien</td>
<td>überprüfen, ggf. anpassen</td>
<td>Marketing</td>
<td>&gt;Tabellen &gt;Artikelverwaltung &gt;Medium sowie Lagerverwaltung &gt;Artikelstamm &gt;Q/Medienartikel</td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Partienverwaltung</td>
<td>Lagersortimente überprüfen, ggf. anpassen</td>
<td>Lager</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h2 id="_8-4-auftragsverwaltung" tabindex="-1"><a class="header-anchor" href="#_8-4-auftragsverwaltung"><span>8.4. Auftragsverwaltung</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>G, W</td>
<td>Sammelfakturen</td>
<td>aufbereiten per Ende des Zeitabschnitts; evtl. gerade neuen, einmaligen Job definieren</td>
<td>EDV</td>
<td>&gt;Auftragsverwaltung &gt;Sammelbearbeitung &gt;Fakturen/Avis aufbereiten &gt;Sammelrechnungen - Aufbereitungsjob</td>
<td>Auftragsverwaltung Sammelfaktura</td>
</tr>
<tr>
<td>W</td>
<td>Alte Aufträge</td>
<td>Job überprüfen, ggf. anpassen</td>
<td>EDV</td>
<td>&gt;Systemorganisation  &gt;Regelmässige Dienste &gt;alte Aufträge kopieren</td>
<td>Systemorganisation</td>
</tr>
<tr>
<td>W</td>
<td>Steuertabelle WBS</td>
<td>überprüfen, ggf. anpassen</td>
<td>EDV</td>
<td>&gt;Auftragsverwaltung &gt;Sammelbearbeitung &gt;Steuertabelle WBS</td>
<td>Auftragsverwaltung</td>
</tr>
<tr>
<td>W</td>
<td>Auftragsarten</td>
<td>überprüfen, ggf. anpassen, insbesondere die Ereignisverknüpfungen überprüfen</td>
<td>Marketing, EDV</td>
<td>&gt;Tabellen</td>
<td></td>
</tr>
<tr>
<td>W, J</td>
<td>Universaltexte</td>
<td>v.a. für WBS-Texte überprüfen, ggf. anpassen</td>
<td>Marketing</td>
<td>&gt;Tabellen &gt;Diverse Tabellen &gt;Universaltext</td>
<td>Systemorganisation</td>
</tr>
</tbody>
</table>
<ul>
<li><RouteLink to="/manual/trade/sammelfakturen.html" title="10. Sammelfakturen (mehrere Rechnungen zusammenfassen)">Auftragsverwaltung Sammelfaktura</RouteLink></li>
<li><RouteLink to="/manual/administration/systemverwaltung.html" title="7. Systemverwaltung">Systemorganisation</RouteLink></li>
<li><RouteLink to="/manual/trade/auftragsverwaltung.html" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></li>
<li></li>
</ul>
<h2 id="_8-5-debitorenverwaltung" tabindex="-1"><a class="header-anchor" href="#_8-5-debitorenverwaltung"><span>8.5. Debitorenverwaltung</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>G, J, W</td>
<td>Zahlungen</td>
<td>für die abzuschliessende Periode einlesen</td>
<td>Buchhaltung</td>
<td>&gt;Debitorenverwaltung &gt;autom. Buchungen ab Datenträger</td>
<td>Buchungen einlesen</td>
</tr>
<tr>
<td>G, J, W</td>
<td>Aggregierung</td>
<td>durchführen</td>
<td>Buchhaltung</td>
<td>&gt;Debitorenverwaltung &gt;aggregierte Buchungen generieren</td>
<td>Debitorenverwaltung</td>
</tr>
<tr>
<td>W</td>
<td>Mahnungen</td>
<td>durchführen</td>
<td>Buchhaltung</td>
<td>&gt;Debitorenverwaltung &gt;Mahnwesen</td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Guthaben</td>
<td>bereinigen</td>
<td>Buchhaltung</td>
<td>&gt;Statistiken, Auswertungen &gt;Debitorenverwaltung &gt;OP-Guthabenliste</td>
<td>Statistiken Debitorenverwaltung</td>
</tr>
<tr>
<td>W</td>
<td>Offene Posten / Einzelbuchungen</td>
<td>Bereinigungslauf durchführen</td>
<td>VDZC, evtl. Buchhaltung</td>
<td>&gt;Debitorenverwaltung &gt;Sammelbearbeitung, Produktion</td>
<td>Debitorenverwaltung</td>
</tr>
<tr>
<td>W</td>
<td>Währungen</td>
<td>Umrechnungskurse pflegen</td>
<td>Buchhaltung</td>
<td>&gt;Tabellen &gt;Buchhaltung &gt;Währungen</td>
<td></td>
</tr>
<tr>
<td>W</td>
<td>Freie Texte</td>
<td>LSV/BAD-Belastungstexte überprüfen</td>
<td>Buchhaltung</td>
<td>&gt;Tabellen &gt;Diverse Tabellen &gt;Freier Text</td>
<td></td>
</tr>
</tbody>
</table>
<ul>
<li><RouteLink to="/referenz/refs/ft.refproc.bucheinl.html" title="Buchungen einlesen">Buchungen einlesen</RouteLink></li>
<li><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="1. Debitorenverwaltung">Debitorenverwaltung</RouteLink></li>
<li><RouteLink to="/referenz/refstat/ft.refstat.deb.html" title="Auswertungen Buchhaltung">Statistiken Debitorenverwaltung</RouteLink></li>
</ul>
<h2 id="_8-6-projektverwaltung" tabindex="-1"><a class="header-anchor" href="#_8-6-projektverwaltung"><span>8.6. Projektverwaltung</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>W</td>
<td>Projekte</td>
<td>überprüfen</td>
<td>Marketing</td>
<td>Projektverwaltung &gt;Projekte</td>
<td>Projekte</td>
</tr>
</tbody>
</table>
<ul>
<li><RouteLink to="/referenz/refs/ft.refdata.projekte.html" title="Projekte">Projekte</RouteLink></li>
</ul>
<h2 id="_8-7-dauerauftragsverwaltung" tabindex="-1"><a class="header-anchor" href="#_8-7-dauerauftragsverwaltung"><span>8.7. Dauerauftragsverwaltung</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>W, G</td>
<td>Sammelfakturen</td>
<td>aufbereiten</td>
<td>EDV</td>
<td>&gt;Dauerauftragsverwaltung &gt;Sammelbearbeitung, Produktion &gt;Daueraufträge aufbereiten</td>
<td></td>
</tr>
<tr>
<td>W, G</td>
<td>Daueraufträge</td>
<td>kontrollieren, ggf. anpassen</td>
<td>Marketing</td>
<td>&gt;Dauerauftragsverwaltung &gt;Sammelbearbeitung, Produktion &gt;Daueraufträge kontrollieren</td>
<td></td>
</tr>
</tbody>
</table>
<h2 id="_8-8-veranstaltungen" tabindex="-1"><a class="header-anchor" href="#_8-8-veranstaltungen"><span>8.8. Veranstaltungen</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>W</td>
<td>Veranstaltungen</td>
<td>kontrollieren, ggf. anpassen</td>
<td>Marketing</td>
<td>&gt;Veranstaltungen &gt;Veranstaltungen</td>
<td></td>
</tr>
</tbody>
</table>
<h2 id="_8-9-statistiken-auswertungen" tabindex="-1"><a class="header-anchor" href="#_8-9-statistiken-auswertungen"><span>8.9. Statistiken, Auswertungen</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>J</td>
<td>Zusagenstatistik nach Zahlungsmodus</td>
<td>Job und Parameter überprüfen, ggf. anpassen</td>
<td>Marketing, EDV</td>
<td>&gt;Statistiken, Auswertungen &gt;Adressverwaltung &gt;</td>
<td>Statistiken Adressverwaltung</td>
</tr>
<tr>
<td>J</td>
<td>Spenden (inkl. zugesagte) nach Höhe</td>
<td>Job und Parameter überprüfen, ggf. anpassen</td>
<td>Marketing, EDV</td>
<td>&gt;Statistiken, Auswertungen &gt;Adressverwaltung &gt;</td>
<td>Statistiken Adressverwaltung</td>
</tr>
<tr>
<td>J</td>
<td>Spenderpyramide</td>
<td>Job und Parameter überprüfen, ggf. anpassen</td>
<td>Marketing, EDV</td>
<td>&gt;Statistiken, Auswertungen &gt;Adressverwaltung &gt;</td>
<td>Statistiken Adressverwaltung</td>
</tr>
<tr>
<td>J</td>
<td>Adressenstatistik nach Status</td>
<td>Job und Parameter überprüfen, ggf. anpassen</td>
<td>Marketing, EDV</td>
<td>&gt;Statistiken, Auswertungen &gt;Adressverwaltung &gt;</td>
<td>Statistiken Adressverwaltung</td>
</tr>
<tr>
<td>J</td>
<td>Kundenspezifische Auswertungen</td>
<td>All jene prüfen, welche als BJob im Hintergrund regelmässig laufen können, Parameter überprüfen, ggf. anpassen</td>
<td>Marketing, EDV</td>
<td>&gt;Statistiken, Auswertungen &gt;.... &gt;Kundenspezifische Auswertungen &gt;</td>
<td></td>
</tr>
<tr>
<td>J</td>
<td>Auftragsstatistik nach Kunden und Medium</td>
<td>Job und Parameter überprüfen, ggf. anpassen</td>
<td>Marketing, EDV</td>
<td>&gt;Statistiken, Auswertungen &gt;Auftragsverwaltung &gt;</td>
<td>Statistiken Auftragsverwaltung</td>
</tr>
<tr>
<td>J</td>
<td>Reportingtool</td>
<td>vorhandene Jobs und deren Parameter überprüfen, ggf. anpassen</td>
<td>Marketing, EDV</td>
<td>&gt;Statistiken, Auswertungen &gt;Reportingtool &gt;</td>
<td>Reportingtool</td>
</tr>
</tbody>
</table>
<ul>
<li><RouteLink to="/referenz/refstat/ft.refstat.adr.html" title="Auswertungen Personen">Statistiken Adressverwaltung</RouteLink></li>
<li><RouteLink to="/referenz/refstat/ft.refstat.auf.html" title="Auswertungen Verkauf">Statistiken Auftragsverwaltung</RouteLink></li>
<li><RouteLink to="/manual/customer/reportingtool.html" title="9. Reportingtool">Reportingtool</RouteLink></li>
</ul>
<h2 id="_8-10-systemorganisation" tabindex="-1"><a class="header-anchor" href="#_8-10-systemorganisation"><span>8.10. Systemorganisation</span></a></h2>
<table>
<thead>
<tr>
<th>Kategorie</th>
<th>Bereich</th>
<th>Arbeitsbeschreibung</th>
<th>wer</th>
<th>Programm</th>
<th>Dokumentations­hinweis</th>
</tr>
</thead>
<tbody>
<tr>
<td>W</td>
<td>Jobs</td>
<td>mit div. internen Stellen und VDZC absprechen und überprüfen ;alte, nicht mehr benötigte  Jobs sollten unbedingt bereinigt werden</td>
<td>EDV</td>
<td>&gt;Systemorganisation &gt;Jobs</td>
<td>Systemorganisation</td>
</tr>
<tr>
<td>W</td>
<td>Regelmässige Dienste</td>
<td>einzelne Dienste (z.T. bereits oben beschrieben) überprüfen, ggf. anpassen</td>
<td>EDV, evtl. VDZC</td>
<td>&gt;Systemorganisation &gt;Regelmässige Dienste &gt;</td>
<td>Systemorganisation</td>
</tr>
</tbody>
</table>
<ul>
<li><RouteLink to="/manual/administration/systemverwaltung.html" title="7. Systemverwaltung">Systemorganisation</RouteLink></li>
</ul>
</div></template>


